import style from "./style";

export const GRID_BOX_TYPE = [
  {
    key: "total_code",
    text: "จำนวนรหัสโค้ดทั้งหมด",
    style: {
      ...style.gird_box.grid_box,
      ...style.gird_box.total_code,
    },
  },
  {
    key: "used_code",
    text: "ใช้งานไปแล้ว",
    style: {
      ...style.gird_box.grid_box,
      ...style.gird_box.used_code,
    },
  },
  {
    key: "unused_code",
    text: "ยังไม่ได้ใช้งาน",
    style: {
      ...style.gird_box.grid_box,
      ...style.gird_box.unused_code,
    },
  },
  {
    key: "void_code",
    text: "ยกเลิก",
    style: { ...style.gird_box.grid_box, ...style.gird_box.void_code },
  },
];

export const STATUS_OPTIONS = [
  { value: "", label: "สถานะทั้งหมด" },
  { value: "available", label: "ยังไม่ได้ใช้งาน" },
  { value: "used", label: "ใช้งานไปแล้ว" },
  { value: "void", label: "ยกเลิก" },
];
